// extracted by mini-css-extract-plugin
export var button = "ArticlesListingModule-module--button--07796";
export var content = "ArticlesListingModule-module--content--afd75";